import { useLanguage } from "@/i18n";

export default function Marquee() {
  const { t } = useLanguage();
  const items = t.marquee;

  const Row = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-mono text-xs uppercase tracking-[0.3em] text-slate-500 sm:px-12 sm:text-sm">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-gradient-to-r from-orange-400 to-amber-400" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="marquee"
      className="relative overflow-hidden border-y border-slate-800/60 bg-slate-950/60 py-6"
    >
      <div className="animate-marquee flex w-max hover:[animation-play-state:paused]">
        <Row />
        <Row hidden />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-slate-950 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-slate-950 to-transparent" />
    </div>
  );
}
